namespace RioERP.Reports {
    export interface InvoiceDetailedReportForm {
        InvoiceDate: Serenity.DateEditor;
        OrderDate: Serenity.DateEditor;
        Invoicenumber: Serenity.StringEditor;
        EPaymentType: Serenity.EnumEditor;
        CustomerName: Serenity.StringEditor;
        EInvoiceTo: Serenity.EnumEditor;
        FranchiseeName: Serenity.StringEditor;
        City: Serenity.StringEditor;
        ProductName: Serenity.StringEditor;
        OrderNumber: Serenity.StringEditor;
        FranchiseeDiscountAmount: Serenity.DecimalEditor;
        OrderDiscount: Serenity.DecimalEditor;
        ProductDiscount: Serenity.DecimalEditor;
        TaxCategoryName: Serenity.StringEditor;
        InvoiceCompanyId: Serenity.LookupEditor;
        Total: Serenity.DecimalEditor;
        DiscountAmount: Serenity.DecimalEditor;
        NetAmount: Serenity.DecimalEditor;
        TaxableAmount: Serenity.DecimalEditor;
        CgstRate: Serenity.DecimalEditor;
        CgstAmount: Serenity.DecimalEditor;
        SgstRate: Serenity.DecimalEditor;
        SgstAmount: Serenity.DecimalEditor;
        IgstRate: Serenity.DecimalEditor;
        IgstAmount: Serenity.DecimalEditor;
        TotalTax: Serenity.DecimalEditor;
        EPaymentStatus: Serenity.EnumEditor;
        InvoiceId: Serenity.LookupEditor;
        FranchiseeId: Serenity.LookupEditor;
        CustomerId: Serenity.LookupEditor;
    }

    export class InvoiceDetailedReportForm extends Serenity.PrefixedContext {
        static formKey = 'Reports.InvoiceDetailedReport';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!InvoiceDetailedReportForm.init)  {
                InvoiceDetailedReportForm.init = true;

                var s = Serenity;
                var w0 = s.DateEditor;
                var w1 = s.StringEditor;
                var w2 = s.EnumEditor;
                var w3 = s.DecimalEditor;
                var w4 = s.LookupEditor;

                Q.initFormType(InvoiceDetailedReportForm, [
                    'InvoiceDate', w0,
                    'OrderDate', w0,
                    'Invoicenumber', w1,
                    'EPaymentType', w2,
                    'CustomerName', w1,
                    'EInvoiceTo', w2,
                    'FranchiseeName', w1,
                    'City', w1,
                    'ProductName', w1,
                    'OrderNumber', w1,
                    'FranchiseeDiscountAmount', w3,
                    'OrderDiscount', w3,
                    'ProductDiscount', w3,
                    'TaxCategoryName', w1,
                    'InvoiceCompanyId', w4,
                    'Total', w3,
                    'DiscountAmount', w3,
                    'NetAmount', w3,
                    'TaxableAmount', w3,
                    'CgstRate', w3,
                    'CgstAmount', w3,
                    'SgstRate', w3,
                    'SgstAmount', w3,
                    'IgstRate', w3,
                    'IgstAmount', w3,
                    'TotalTax', w3,
                    'EPaymentStatus', w2,
                    'InvoiceId', w4,
                    'FranchiseeId', w4,
                    'CustomerId', w4
                ]);
            }
        }
    }
}
